import React from "react";
import { ApiEndpointI } from "../listaEndpointsPlanes";
import { DownloadFileIcon } from "assets/icons/DownloadFileIcon";
import { LupaIcon } from "assets/icons/LupaIcon";
import { descargarJSON } from "services/request/downloadJSON";
import { Button } from "react-bootstrap";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";

interface Props {
  elemento: ApiEndpointI;
}

const APP_API = window.configs.REACT_APP_API;
const BASE_URL = APP_API.slice(0, -1);

export const EndpointsRow = ({ elemento }: Props) => {
  const handleClickDescargar = async (endpoint: string) => {
    try {
      await descargarJSON({ title: endpoint, endpoint });
      showSuccessToast("Se descargo el JSON correctamente!");
    } catch (err) {
      showErrorToast("No fue posible descargar el JSON.");
    }
  };

  return (
    <tr className="table-row" key={`EndpointTable-${elemento.titulo}`}>
      <td>{elemento.titulo}</td>
      <td style={{ textAlign: "center" }}>
        <a
          href={BASE_URL + elemento.urlConsultar}
          target="_blank"
          rel="noreferrer"
        >
          <LupaIcon />
        </a>
      </td>
      <td style={{ textAlign: "center" }}>
        <Button
          variant="link"
          onClick={() => handleClickDescargar(elemento.urlConsultar)}
        >
          <DownloadFileIcon />
        </Button>
      </td>
    </tr>
  );
};
